import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IOption } from "~app/common/models/options-models";
import { VKForkalkylTradslagDTO } from "~app/features/virkeskop/models/tradslag/tradslag-models";
import { ForkalkylService } from "../../../services/forkalkyl.service";

@Component({
    selector: "rask-add-tradslag-button",
    templateUrl: "./add-tradslag-button.component.html",
    styleUrls: ["./add-tradslag-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ActionButtonComponent]
})
export class AddTradslagButtonComponent implements OnInit, OnDestroy {
    @Input() readonly = false;
    @Input() selectedTradslag: VKForkalkylTradslagDTO[]  = [];
    @Output() tradslagAdded = new EventEmitter<VKForkalkylTradslagDTO>();

    private readonly forkalkylService = inject(ForkalkylService);
    private readonly ngUnsubscribe$ = new Subject<void>();

    private tradslag: VKForkalkylTradslagDTO[] = [];

    protected get tradslagOptions(): IOption[] {
        return this.tradslag
            .filter(x => !this.selectedTradslag
                .some(y => y.id === x.id))
            .map(x => ({
                key: x.id.toString(),
                value: x.namn,
                grupp: ""
            }));
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit() {
        this.forkalkylService.tradslag$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(x => this.tradslag = x);
    }

    tradslagSelected(tradslag: IOption) {
        this.tradslagAdded.emit(this.tradslag
            .find(t => t.id.toString() === tradslag.key));
    }
}
